import { http } from '@/http/axios.js'
// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/merchant/page',
    method: 'get',
    params
  })
}
// 状态
export function changeStatusAPI(data) {
  return http({
    url: '/admin/merchant/status/edit',
    method: 'post',
    data
  })
}
// 删除
export function deleteMerchantAPI(id) {
  return http({
    url: '/admin/merchant/delete',
    method: 'post',
    data: { id }
  })
}
// 新增
export function addMerchantAPI(data) {
  return http({
    url: '/admin/merchant/add',
    method: 'post',
    data
  })
}
// 编辑
export function editMerchantAPI(data) {
  return http({
    url: '/admin/merchant/edit',
    method: 'post',
    data
  })
}
// 详情
export function getMerchantDetailAPI(id) {
  return http({
    url: '/admin/merchant/detail',
    method: 'get',
    params: { id }
  })
}
